export default __webpack_public_path__ + "static/media/TokiRGB_blue.95e538c9.png";